'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function shallowClone(data) {
  if (Array.isArray(data)) {
    return [].concat(_toConsumableArray(data));
  } else if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
    return _extends({}, data);
  }
  return data;
}

exports.default = shallowClone;


//////////////////
// WEBPACK FOOTER
// ./node_modules/recycle/lib/shallowClone.js
// module id = 1513
// module chunks = 57